import { Group, Select, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useEffect } from "react";
import Button from "../../components/Button";
import DescriptionField from "../../components/descriptionField";
import InputField from "../../components/inputField";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import {
  alphaNumericRegex,
  descriptionRegex,
  videoUrlRegex,
} from "../../constants/index";
import { addAndEditData } from "../generalPostAndEditData";

export const AddFaq = ({
  opened,
  setOpened,
  allFAQCategories,
  setUpdate,
  editData,
  setEditData,
  editModalState,
  setEditModalState,
  setLoading,
}) => {
  const allFaqTypes = allFAQCategories?.map((category) => ({
    label: category.faqCatName,
    value: category._id,
  }));
  console.log("hiii", allFaqTypes);
  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      faqCategory: "",
      faqQuestion: "",
      faqAnswer: "",
      faqVideoUrl: "",
      faqVideoName: "",
    },

    validate: {
      faqCategory: (value) => (value ? null : "Please select a valid faq type"),

      faqQuestion: (value) =>
        value?.trim()?.length > 1 && descriptionRegex.test(value.trim())
          ? null
          : "Alphabetic Name with 2 or more characters",
      faqAnswer: (value) =>
        value?.trim()?.length > 1 && descriptionRegex.test(value.trim())
          ? null
          : "Description with 20 or more characters",
      faqVideoName: (value) =>
        value?.trim()?.length > 1 && alphaNumericRegex.test(value.trim())
          ? null
          : "Please Enter Valid Video Name",
      faqVideoUrl: (value) =>
        value?.trim()?.length > 1 && videoUrlRegex.test(value.trim())
          ? null
          : "Please Enter Valid Video Url",
    },
  });

  useEffect(() => {
    if (editModalState) {
      form.setValues({
        faqCategory: editData?.faqCategory?._id,
        faqQuestion: editData?.faqQuestion,
        faqAnswer: editData?.faqAnswer,
        faqVideoUrl: editData?.faqVideoUrl,
        faqVideoName: editData?.faqVideoName,
      });
    }
  }, [opened]);

  const onSubmit = (values) => {
    let url = "";
    if (editModalState) {
      values.faqId = editData._id;
      url = "faq/editFaq";
      setEditData({});
      setEditModalState(false);
    } else {
      url = "faq/addFaq";
    }
    form.reset();
    setLoading(true);
    addAndEditData(values, setOpened, setUpdate, url);
  };
  const InternalContent = (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Text mb={0} weight={500}>
        FAQ Type
      </Text>
      <Select
        styles={{
          input: {
            padding: "1.2rem",
          },
        }}
        required
        withAsterisk={false}
        placeholder="Select FAQ Type"
        data={allFaqTypes}
        // searchable
        nothingFound="No FAQ Type found"
        {...form.getInputProps("faqCategory")}
      />
      <Text mt="md" mb={0} weight={500}>
        FAQ Question
      </Text>

      <DescriptionField
        maxRows={3}
        minRows={2}
        autosize={true}
        width="100%"
        placeholder="Enter FAQ Question"
        form={form}
        validateName="faqQuestion"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />

      <Text mt="md" mb={0} weight={500}>
        FAQ Answer
      </Text>
      <DescriptionField
        maxRows={4}
        minRows={3}
        autosize={true}
        width="100%"
        placeholder="Enter FAQ Answer"
        form={form}
        validateName="faqAnswer"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />
      <Text mt="md" mb={0} weight={500}>
        FAQ Video URL
      </Text>
      <InputField
        width="100%"
        placeholder="Enter FAQ Video URL"
        form={form}
        validateName="faqVideoUrl"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />
      <Text mt="md" mb={0} weight={500}>
        FAQ Video Name
      </Text>
      <InputField
        width="100%"
        placeholder="Enter FAQ Video Name"
        form={form}
        // validateName="faqVideoName"
        validateName="faqVideoName"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />

      <Group position="right" pt="xl">
        <Button
          title={"Clear"}
          fontWeight="700"
          onClick={() => {
            form.reset();
          }}
        />
        <Button
          title={editModalState ? "Update" : "Add"}
          primary={true}
          fontWeight="700"
          type="submit"
        />
      </Group>
    </form>
  );

  return (
    <ModalWrapper
      opened={opened}
      setOpened={setOpened}
      InternalComponent={InternalContent}
      title={editModalState ? "Edit FAQ" : "Add FAQ"}
      form={form}
      setEditData={setEditData}
      setEditModalState={setEditModalState}
      addEdit={true}
    />
  );
};
